// extracted by mini-css-extract-plugin
export default {"header":"trades_header__ixCiD","liveEnvironmentContainer":"trades_liveEnvironmentContainer__OEvhH"};